import { registerSystem } from "yage/components/ComponentRegistry";
import { System } from "yage/components/System";
import { Component, Schema, defaultValue, type } from "yage/decorators/type";
import { GameModel } from "yage/game/GameModel";
import { ChildSchema } from "yage/schemas/entity/Child";
import { MaterialsOnCratePickupSchema } from "../effects/MaterialsOnCratePickup";
import { EnemyTypeSchema, PlayerTypeSchema } from "yage/components/entity/Types";

@Component("MaterialsOnCratePickupEnhancer")
export class MaterialsOnCratePickupEnhancerSchema extends Schema {
  @type("number")
  @defaultValue(15)
  materials: number;
}

class MaterialsOnCratePickupSystem implements System {
  schema = MaterialsOnCratePickupEnhancerSchema;
  type = "MaterialsOnCratePickupEnhancer";
  dependencies = ["Child"];
  init(entity: number, gameModel: GameModel) {
    if (
      !gameModel.hasComponent(entity, PlayerTypeSchema) &&
      !gameModel.hasComponent(entity, EnemyTypeSchema) &&
      gameModel.hasComponent(entity, ChildSchema)
    ) {
      const parent = gameModel.getTypedUnsafe(entity, ChildSchema).parent!;
      if (!gameModel.hasComponent(parent, "MaterialsOnCratePickup")) {
        gameModel.addComponent(parent, MaterialsOnCratePickupSchema);
      }
      gameModel.getTypedUnsafe(parent, MaterialsOnCratePickupSchema).materials += gameModel.getTypedUnsafe(
        entity,
        MaterialsOnCratePickupEnhancerSchema
      ).materials;
    }
  }

  cleanup(entity: number, gameModel: GameModel, ejecting: boolean) {
    if (
      !gameModel.hasComponent(entity, PlayerTypeSchema) &&
      !gameModel.hasComponent(entity, EnemyTypeSchema) &&
      gameModel.hasComponent(entity, ChildSchema)
    ) {
      const parent = gameModel.getTypedUnsafe(entity, ChildSchema).parent!;
      if (gameModel.hasComponent(parent, "MaterialsOnCratePickup")) {
        gameModel.getTypedUnsafe(parent, MaterialsOnCratePickupSchema).materials -= gameModel.getTypedUnsafe(
          entity,
          MaterialsOnCratePickupEnhancerSchema
        ).materials;
      }
    }
  }
}
registerSystem(MaterialsOnCratePickupSystem);
